import { render, staticRenderFns } from "./ProductConfigCard.vue?vue&type=template&id=6aa587dc&scoped=true"
import script from "./ProductConfigCard.vue?vue&type=script&lang=js"
export * from "./ProductConfigCard.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigCard.vue?vue&type=style&index=0&id=6aa587dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa587dc",
  null
  
)

export default component.exports